import React from 'react';
import { useSelector } from '../../redux/modules/helpers/useSelector';
import { blogRoutes, galleriesRoutes, modelsAndArtistsRoutes, moviesRoutes, updatesRoutes } from '../../utils/router';
import { HeaderItemWithPopover } from './HeaderItemWithPopover';
import { HeaderPopovers } from './HeaderProvider';
import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components/macro';
import { InternalMenuLink } from './InternalMenuLink';
import { useFeatureFlags } from 'src/client/helpers/useFeatureFlags';
import { TABLET_LANDSCAPE } from 'src/client/constants/mediaQueries';
import { SeoCategoriesMenu } from 'src/client/components/SeoCategoriesMenu/SeoCategoriesMenu';
import { LiveGirlsMenu } from 'src/client/components/LiveGirls/LiveGirlsMenu';
import { MoreGirls } from './MoreGirls';

export const InternalLinks = () => {
  const user = useSelector((state) => state.auth.user);
  const config = useSelector((state) => state.app.config);
  const { showAIGirlsLink } = useFeatureFlags();
  const showAiLink = showAIGirlsLink && user?.validSubscription;

  return (
    <InternalLinksContainer>
      <InternalMenuLink show={!!config.hasUpdates} url="/updates" path={updatesRoutes.map((route) => route.path)}>
        UPDATES
      </InternalMenuLink>

      <InternalMenuLink
        url="/erotic-films"
        path={moviesRoutes.map((route) => route.path)}
        show={config.movies.requiresAuth ? config.movies.active && !!user : config.movies.active}
      >
        FILMS
      </InternalMenuLink>

      <InternalMenuLink url="/galleries" path={galleriesRoutes.map((route) => route.path)}>
        PHOTOS
      </InternalMenuLink>

      {showAiLink ? (
        <HeaderItemWithPopover
          headerPopover={HeaderPopovers.AI_GIRLS}
          menuLink="/models"
          menuText="MODELS"
          staticContent
        >
          <Popover>
            <StyledNavLink to="models">Models</StyledNavLink>
            <StyledNavLink to="/ai-chat">🔥 AI Chat Demo</StyledNavLink>
          </Popover>
        </HeaderItemWithPopover>
      ) : (
        <InternalMenuLink url="/models" path={modelsAndArtistsRoutes.map((route) => route.path)}>
          MODELS
        </InternalMenuLink>
      )}

      <InternalMenuLink
        url="/blog"
        path={blogRoutes.map((route) => route.path)}
        show={config.hasBlog && !config.featureFlags?.enableSeoCategoriesMenu}
      >
        BLOG
      </InternalMenuLink>

      {config.featureFlags?.enableSeoCategoriesMenu && <SeoCategoriesMenu />}
      <LiveGirlsMenu shouldRender />
      <MoreGirls />
    </InternalLinksContainer>
  );
};

const InternalLinksContainer = styled.nav`
  display: none;
  flex-direction: row:
  align-items: center;
  justify-content: flex-start;
  flex-wrap: nowrap;
  align-self: stretch;
  margin-right: 5px;

  @media ${TABLET_LANDSCAPE} {
    display: flex;
  }
`;

export const Popover = styled.div`
  background: ${(props) => props.theme.primary1};
  border-color: ${(props) => props.theme.primary3};
  border-width: 1px;
  border-style: solid;
  border-radius: 2px;
  padding: 15px;
`;

const popoverLinkCSS = css`
  display: block;
  text-align: center;
  line-height: 25px;
  color: ${(props) => props.theme.headerBarPrimary2};
  font-size: 1rem;

  &:hover {
    text-decoration: none;
    color: ${(props) => props.theme.headerBarPrimary4};
  }

  &.left {
    text-align: left;
  }
`;

export const StyledNavLink = styled(Link)`
  ${popoverLinkCSS}
`;

export const StyledAnchor = styled.a`
  ${popoverLinkCSS}
`;
